/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CreateTopUpRequest, TopUpTransactionDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiTopUpController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-top-up-controller
   * @name GetIssuedTopUps
   * @request GET:/api/v1/top-ups
   */
  getIssuedTopUps = (params: RequestParams = {}) =>
    this.http.request<TopUpTransactionDto[], any>({
      path: `/v1/top-ups`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getIssuedTopUpsPath = '/v1/top-ups'
  static getIssuedTopUpsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-top-up-controller
   * @name Create4
   * @request POST:/api/v1/top-ups
   */
  create = (data: CreateTopUpRequest, params: RequestParams = {}) =>
    this.http.request<TopUpTransactionDto, any>({
      path: `/v1/top-ups`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/top-ups'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags api-top-up-controller
   * @name GetTopUpsByStatus
   * @request GET:/api/v1/top-ups/status/{status}
   */
  getTopUpsByStatus = (status: string, params: RequestParams = {}) =>
    this.http.request<TopUpTransactionDto[], any>({
      path: `/v1/top-ups/status/${status}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getTopUpsByStatusPath = '/v1/top-ups/status/${status}'
  static getTopUpsByStatusMethod = 'GET'
}
